export default "__VITE_ASSET__BywXSEpw__"